/**
 * Updates object properties.
 * @param {Object} object - Object to be updated/
 * @param {Object} changedProperties - Object with the properties to be changed and their new values.
 * @return {Object} New object with updated properties.
 */
export default function immmutableUpdateObject(object, changedProperties) {
  return Object.assign({}, object, changedProperties);
}
